// Exports the "autoresize" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/autoresize')
//   ES2015:
//     import 'tinymce/plugins/autoresize'
require('./plugin.js');


// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/autoresize/index.js